import script from "./ClassroomLobby.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassroomLobby.vue?vue&type=script&setup=true&lang=js"

import "./ClassroomLobby.vue?vue&type=style&index=0&id=1a757776&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a757776"]])

export default __exports__